import { Color } from '@pixi/color';
import { BitmapText } from 'pixi.js-legacy';

import { themingInstance } from '@exchange/libs/utils/theming/src';

export default class TextValue extends BitmapText {
  constructor({ fontName, fontSize = 6, text = '', light = true }: { fontName: string; text: string; light?: boolean; fontSize?: number }) {
    super(text, {
      fontName,
      fontSize,
      align: 'right',
      tint: new Color(themingInstance.getColor(light ? '--v-theme-text-primary' : '--text-0')).toNumber(),
    });
  }
}
